import Router from 'next/router';
import { NextPageContext } from 'next';

type Params = Pick<NextPageContext, 'reduxStore' | 'res'> & {
  next: string | null;
};

const checkAuthStrategyLoginRedirect = ({ next, reduxStore, res }: Params) => {
  const {
    serverConfig: { authLoginRedirectStrategy, authStrategies }
  } = reduxStore.getState();

  if (!authLoginRedirectStrategy) return false;

  const activeStrategy = authStrategies?.find(
    (strategy) => strategy.name === authLoginRedirectStrategy
  );

  if (!activeStrategy) return false;

  // check if next page is course login page in which case
  // we do not redirect to the auth login page
  if (next?.indexOf('/courses/') === 0) return false;

  const isServer = typeof window === 'undefined';

  const redirectUrl = `/api/auth/${authLoginRedirectStrategy}/authenticate?next=${
    next || '/'
  }`;

  if (isServer && res) {
    res.writeHead(302, { Location: redirectUrl });
    res.end();
  } else {
    Router.push(redirectUrl);
  }

  return true;
};

export default checkAuthStrategyLoginRedirect;
